angular.module('homebot.directives')

  .directive('collapse', ['Dictionary', function(Dictionary){
    return {
      restrict: 'A',
      controllerAs: 'collapse',
      bindToController: {

      },
      scope: {},

      controller: function(){

      },

      link: function($scope, el, attrs, ctrl){
        // $attrs.$observe('collapse', ctrl.update);
      }
    }

  }]);
